import React from 'react';
export function Closing() {
  return <section className="w-full bg-transparent py-8" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-73">
        <div className="bg-[#D4A843] text-white p-6 md:p-8 rounded-lg relative overflow-hidden" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-75">
            El próximo domingo...
          </h2>
          <div className="space-y-3 text-lg leading-relaxed" data-id="element-76">
            <p data-id="element-77">
              El próximo domingo podés estar como siempre: buscando actividades
              a último momento, armando material con lo que encontrás, llegando
              al lunes con la planificación a medio hacer...
            </p>
            <p className="font-semibold" data-id="element-78">O podés tener TODO tu año resuelto.</p>
            <p data-id="element-79">
              Cada semana planificada.
              <br data-id="element-80" />
              Cada actividad secuenciada.
              <br data-id="element-81" />
              Cada rúbrica lista.
              <br data-id="element-82" />
              Cada informe con plantilla.
            </p>
            <p className="text-2xl font-bold text-center pt-6" data-id="element-83">Vos elegís.</p>
          </div>
        </div>
      </div>
    </section>;
}